/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ApiService, MedicationGroup } from '@midas/shared/common';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { map, Observable } from 'rxjs';
import { IQuerySingle } from '../ui-query-single';
import { PagedResult } from '../ui-query-select';

@Component({
  selector: 'midas-ui-medication-group-query-single',
  templateUrl: './ui-medication-group-query-single.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    TranslocoModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiMedicationGroupQuerySingleComponent),
      multi: true,
    },
  ],
})
export class UiMedicationGroupQuerySingleComponent extends IQuerySingle<MedicationGroup> {
  constructor(
    private api: ApiService,
    private transloco: TranslocoService,
    protected _change: ChangeDetectorRef,
  ) {
    super(_change);
  }

  getItemsBySearchString(
    searchString?: string | null,
    startingIndex = 0,
    numberOfRecords = 10,
  ): Observable<PagedResult<MedicationGroup>> {
    return this.api.get<{ count: number; items: MedicationGroup[] }>('/medications/list', {
      startingIndex,
      numberOfRecords,
      searchString,
    });
  }

  getItemById(id: number): Observable<MedicationGroup | null> {
    return this.api
      .get<{ count: number; items: MedicationGroup[] }>('/medications/list', {
        startingIndex: 0,
        numberOfRecords: 1,
        ids: [id],
      })
      .pipe(map((res) => (res.count > 0 ? res.items[0] : null)));
  }

  getDisplayName(item: MedicationGroup): string {
    return item.medicationGroupDescription;
  }

  getPlaceholderText(): string {
    return this.transloco.translate('Search Medications');
  }
}
